import { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { createReview } from '../lib/firebaseService';
import { Star, Send } from 'lucide-react';

export default function ReviewForm() {
  const [formData, setFormData] = useState({
    name: '',
    business: '',
    email: '',
    rating: 5,
    text: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.text.trim()) {
      toast.error('Ad və rəy mətni tələb olunur');
      return;
    }

    setSubmitting(true);
    try {
      await createReview(formData);
      toast.success('Rəyiniz göndərildi! Admin təsdiqindən sonra yayımlanacaq.');
      setFormData({
        name: '',
        business: '',
        email: '',
        rating: 5,
        text: ''
      });
    } catch (error) {
      console.error('Xəta:', error);
      toast.error('Rəy göndərilə bilmədi');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="review-form" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-block bg-black text-white px-4 py-1 rounded-full text-sm font-medium mb-4">
            <Star className="w-4 h-4 inline mr-1" />
            Sizin Rəyiniz
          </div>
          <h2 className="text-4xl font-bold text-black mb-4">
            Təcrübənizi Paylaşın
          </h2>
          <p className="text-lg text-gray-600">
            Platformamız haqqında düşüncələrinizi bizimlə paylaşın
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="name">Adınız *</Label>
                <Input
                  id="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  placeholder="Adınız və Soyadınız"
                  className="h-11"
                />
              </div>

              <div>
                <Label htmlFor="business">Biznes/Mağaza Adı</Label>
                <Input
                  id="business"
                  value={formData.business}
                  onChange={(e) => setFormData({ ...formData, business: e.target.value })}
                  placeholder="Mağazanızın adı"
                  className="h-11"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="email">Email (ixtiyari)</Label>
              <Input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="email@example.com"
                className="h-11"
              />
            </div>

            <div>
              <Label>Qiymətləndirmə *</Label>
              <div className="flex gap-2 mt-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setFormData({ ...formData, rating: star })}
                    className="transition-transform hover:scale-110"
                  >
                    <Star
                      className={`w-8 h-8 ${
                        star <= formData.rating
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'text-gray-300'
                      }`}
                    />
                  </button>
                ))}
              </div>
            </div>

            <div>
              <Label htmlFor="text">Rəyiniz *</Label>
              <Textarea
                id="text"
                value={formData.text}
                onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                required
                rows={5}
                placeholder="Platformamız haqqında düşüncələrinizi yazın..."
                className="resize-none"
              />
            </div>

            <Button
              type="submit"
              disabled={submitting}
              className="w-full h-12 bg-black hover:bg-gray-800 text-white"
            >
              {submitting ? 'Göndərilir...' : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Rəyi Göndər
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
